import axios from "axios";
import { API_BASE_URL } from "../constants/api-urls";
import superAdminApi from "./superAdminApi";
import api from "./api";

const publicApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

export const cmsExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

/** Public: fetch active CMS page by type */
export const fetchPublicCmsPage = async (pageType) => {
  const res = await publicApi.get(`/cms/${pageType}`);
  return res.data?.data?.page ?? null;
};

/** Public: fetch active terms by module */
export const fetchPublicTerms = async (moduleName) => {
  const res = await publicApi.get(`/public/terms/${moduleName}`);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: list CMS pages */
export const fetchCmsPages = async (params = {}) => {
  const res = await superAdminApi.get("/super-admin/cms/pages", { params });
  return res.data?.data ?? { items: [], total: 0, page: 1, pageSize: 20, totalPages: 1 };
};

/** Super Admin: get CMS page by id */
export const fetchCmsPageById = async (id) => {
  const res = await superAdminApi.get(`/super-admin/cms/pages/${id}`);
  return res.data?.data?.page ?? null;
};

/** Super Admin: version history */
export const fetchCmsPageHistory = async (pageType) => {
  const res = await superAdminApi.get(`/super-admin/cms/history/${pageType}`);
  return res.data?.data?.history ?? [];
};

/** Super Admin: create CMS page */
export const createCmsPage = async (payload) => {
  const res = await superAdminApi.post("/super-admin/cms/pages", payload);
  return res.data?.data?.page ?? null;
};

/** Super Admin: update CMS page */
export const updateCmsPage = async (id, payload) => {
  const res = await superAdminApi.put(`/super-admin/cms/pages/${id}`, payload);
  return res.data?.data?.page ?? null;
};

/** Super Admin: publish CMS page */
export const publishCmsPage = async (id) => {
  const res = await superAdminApi.post(`/super-admin/cms/pages/${id}/publish`);
  return res.data?.data?.page ?? null;
};

/** Super Admin: unpublish CMS page */
export const unpublishCmsPage = async (id) => {
  const res = await superAdminApi.post(`/super-admin/cms/pages/${id}/unpublish`);
  return res.data?.data?.page ?? null;
};

/** Super Admin: create new version from active */
export const createCmsPageNewVersion = async (pageType) => {
  const res = await superAdminApi.post(`/super-admin/cms/pages/${pageType}/new-version`);
  return res.data?.data?.page ?? null;
};

/** Super Admin: list terms */
export const fetchTermsList = async (params = {}) => {
  const res = await superAdminApi.get("/super-admin/terms/terms", { params });
  return res.data?.data ?? { items: [], total: 0, page: 1, pageSize: 20, totalPages: 1 };
};

/** Super Admin: get terms by id */
export const fetchTermsById = async (id) => {
  const res = await superAdminApi.get(`/super-admin/terms/terms/${id}`);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: terms history */
export const fetchTermsHistory = async (moduleName) => {
  const res = await superAdminApi.get(`/super-admin/terms/history/${moduleName}`);
  return res.data?.data?.history ?? [];
};

/** Super Admin: create terms */
export const createTerms = async (payload) => {
  const res = await superAdminApi.post("/super-admin/terms/terms", payload);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: update terms */
export const updateTerms = async (id, payload) => {
  const res = await superAdminApi.put(`/super-admin/terms/terms/${id}`, payload);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: publish terms */
export const publishTerms = async (id) => {
  const res = await superAdminApi.post(`/super-admin/terms/terms/${id}/publish`);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: unpublish terms */
export const unpublishTerms = async (id) => {
  const res = await superAdminApi.post(`/super-admin/terms/terms/${id}/unpublish`);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: new terms version */
export const createTermsNewVersion = async (moduleName) => {
  const res = await superAdminApi.post(`/super-admin/terms/terms/${moduleName}/new-version`);
  return res.data?.data?.terms ?? null;
};

/** Super Admin: delete terms version */
export const deleteTerms = async (id) => {
  await superAdminApi.post(`/super-admin/terms/terms/${id}/delete`);
};

/** Authenticated user: check acceptance status */
export const fetchTermsAcceptanceStatus = async (moduleName) => {
  const res = await api.get(`/terms/acceptance/${moduleName}`);
  return res.data?.data?.acceptance ?? null;
};

/** Authenticated user: accept terms */
export const acceptTerms = async (moduleName) => {
  const res = await api.post("/terms/accept", { module_name: moduleName });
  return res.data?.data?.acceptance ?? null;
};
